import { render, staticRenderFns } from "./BrandPanel.vue?vue&type=template&id=c2f15728&scoped=true&"
import script from "./BrandPanel.vue?vue&type=script&lang=ts&"
export * from "./BrandPanel.vue?vue&type=script&lang=ts&"
import style0 from "./BrandPanel.vue?vue&type=style&index=0&id=c2f15728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f15728",
  null
  
)

export default component.exports